export default {
  "imgSrc": "http://sc.68design.net/qita7/HappyChildhood/images/HappyChildhood_3019.jpg",
  "bgColor": "#FFFFFF",
  "items": [{
    "title": "树1",
    "desc": "沙树",
    "type": "polygon",
    "color": "red",
    "children": [{
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 163.59763313609466,
      "y": 479.4319526627218,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 161.32544378698225,
      "ty": 472.61538461538464,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 161.32544378698225,
      "y": 472.61538461538464,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 288.5680473372781,
      "ty": 347.64497041420117,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 288.5680473372781,
      "y": 347.64497041420117,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 306.7455621301775,
      "ty": 356.73372781065086,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 306.7455621301775,
      "y": 356.73372781065086,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 349.9171597633136,
      "ty": 420.3550295857988,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 349.9171597633136,
      "y": 420.3550295857988,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 372.63905325443784,
      "ty": 456.71005917159755,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 372.63905325443784,
      "y": 456.71005917159755,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 374.91124260355036,
      "ty": 465.7988165680473,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 374.91124260355036,
      "y": 465.7988165680473,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 395.3609467455621,
      "ty": 504.42603550295854,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 395.3609467455621,
      "y": 504.42603550295854,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 418.08284023668637,
      "ty": 540.7810650887574,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 418.08284023668637,
      "y": 540.7810650887574,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 418.08284023668637,
      "ty": 547.5976331360946,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 418.08284023668637,
      "y": 547.5976331360946,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 386.2721893491124,
      "ty": 545.3254437869822,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 386.2721893491124,
      "y": 545.3254437869822,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 411.266272189349,
      "ty": 574.8639053254437,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 411.266272189349,
      "y": 574.8639053254437,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 429.4437869822485,
      "ty": 608.9467455621301,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 429.4437869822485,
      "y": 608.9467455621301,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 427.1715976331361,
      "ty": 629.396449704142,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 427.1715976331361,
      "y": 629.396449704142,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 420.3550295857988,
      "ty": 636.2130177514792,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 420.3550295857988,
      "y": 636.2130177514792,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 404.44970414201185,
      "ty": 638.4852071005917,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 404.44970414201185,
      "y": 638.4852071005917,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 390.8165680473373,
      "ty": 631.6686390532544,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 390.8165680473373,
      "y": 631.6686390532544,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 397.6331360946745,
      "ty": 663.4792899408284,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 397.6331360946745,
      "y": 663.4792899408284,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 399.905325443787,
      "ty": 668.0236686390532,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 399.905325443787,
      "y": 668.0236686390532,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 422.62721893491124,
      "ty": 693.0177514792899,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 422.62721893491124,
      "y": 693.0177514792899,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 104.52071005917159,
      "ty": 745.2781065088757,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 104.52071005917159,
      "y": 745.2781065088757,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 147.69230769230768,
      "ty": 677.112426035503,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 147.69230769230768,
      "y": 677.112426035503,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 163.59763313609466,
      "ty": 631.6686390532544,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 163.59763313609466,
      "y": 631.6686390532544,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 152.23668639053253,
      "ty": 636.2130177514792,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 152.23668639053253,
      "y": 636.2130177514792,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 159.0532544378698,
      "ty": 622.5798816568047,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 159.0532544378698,
      "y": 622.5798816568047,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 134.05917159763314,
      "ty": 622.5798816568047,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 134.05917159763314,
      "y": 622.5798816568047,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 122.69822485207101,
      "ty": 613.491124260355,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 122.69822485207101,
      "y": 613.491124260355,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 120.42603550295857,
      "ty": 604.4023668639053,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 120.42603550295857,
      "y": 604.4023668639053,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 136.33136094674555,
      "ty": 581.6804733727811,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 136.33136094674555,
      "y": 581.6804733727811,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 140.8757396449704,
      "ty": 572.5917159763313,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 140.8757396449704,
      "y": 572.5917159763313,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 145.42011834319527,
      "ty": 561.2307692307692,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 145.42011834319527,
      "y": 561.2307692307692,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 172.68639053254438,
      "ty": 545.3254437869822,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 172.68639053254438,
      "y": 545.3254437869822,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 188.59171597633136,
      "ty": 522.603550295858,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 188.59171597633136,
      "y": 522.603550295858,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 190.8639053254438,
      "ty": 513.5147928994082,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 190.8639053254438,
      "y": 513.5147928994082,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 170.41420118343194,
      "ty": 513.5147928994082,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 170.41420118343194,
      "y": 513.5147928994082,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 149.96449704142012,
      "ty": 513.5147928994082,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 149.96449704142012,
      "y": 513.5147928994082,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 156.7810650887574,
      "ty": 497.60946745562126,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 156.7810650887574,
      "y": 497.60946745562126,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 156.7810650887574,
      "ty": 490.79289940828403,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 156.7810650887574,
      "y": 490.79289940828403,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 163.59763313609466,
      "ty": 479.4319526627218,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }],
    "x": 0,
    "y": 0,
    "cx": 0,
    "cy": 0,
    "cx2": 0,
    "cy2": 0,
    "tx": 0,
    "ty": 0,
    "width": 0,
    "height": 0,
    "r": 0,
    "fill": false,
    "selected": false
  }, {
    "title": "树2",
    "desc": "沙树2",
    "type": "polygon",
    "color": "red",
    "children": [{
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 967.9526627218935,
      "y": 522.603550295858,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1024.7573964497042,
      "ty": 465.7988165680473,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1024.7573964497042,
      "y": 465.7988165680473,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1036.1183431952663,
      "ty": 472.61538461538464,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1036.1183431952663,
      "y": 472.61538461538464,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1054.2958579881656,
      "ty": 502.1538461538461,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1054.2958579881656,
      "y": 502.1538461538461,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1065.6568047337278,
      "ty": 522.603550295858,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1065.6568047337278,
      "y": 522.603550295858,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1074.7455621301774,
      "ty": 538.508875739645,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1074.7455621301774,
      "y": 538.508875739645,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1079.2899408284022,
      "ty": 545.3254437869822,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1079.2899408284022,
      "y": 545.3254437869822,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1074.7455621301774,
      "ty": 554.4142011834319,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1074.7455621301774,
      "y": 554.4142011834319,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1072.473372781065,
      "ty": 556.6863905325444,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1072.473372781065,
      "y": 556.6863905325444,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1086.1065088757396,
      "ty": 579.4082840236687,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1086.1065088757396,
      "y": 579.4082840236687,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1083.8343195266273,
      "ty": 593.0414201183431,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1083.8343195266273,
      "y": 593.0414201183431,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1079.2899408284022,
      "ty": 595.3136094674556,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1079.2899408284022,
      "y": 595.3136094674556,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1072.473372781065,
      "ty": 595.3136094674556,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1072.473372781065,
      "y": 595.3136094674556,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1072.473372781065,
      "ty": 602.1301775147929,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1072.473372781065,
      "y": 602.1301775147929,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1074.7455621301774,
      "ty": 606.6745562130177,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1074.7455621301774,
      "y": 606.6745562130177,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1070.2011834319526,
      "ty": 615.7633136094674,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1070.2011834319526,
      "y": 615.7633136094674,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 954.3195266272189,
      "ty": 624.8520710059171,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 954.3195266272189,
      "y": 624.8520710059171,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 958.8639053254436,
      "ty": 613.491124260355,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 958.8639053254436,
      "y": 613.491124260355,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 967.9526627218935,
      "ty": 597.5857988165681,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 967.9526627218935,
      "y": 597.5857988165681,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 961.1360946745561,
      "ty": 597.5857988165681,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 961.1360946745561,
      "y": 597.5857988165681,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 965.6804733727811,
      "ty": 590.7692307692307,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 965.6804733727811,
      "y": 590.7692307692307,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 949.775147928994,
      "ty": 590.7692307692307,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 949.775147928994,
      "y": 590.7692307692307,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 949.775147928994,
      "ty": 583.9526627218935,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 949.775147928994,
      "y": 583.9526627218935,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 956.5917159763313,
      "ty": 572.5917159763313,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 956.5917159763313,
      "y": 572.5917159763313,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 958.8639053254436,
      "ty": 563.5029585798816,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 958.8639053254436,
      "y": 563.5029585798816,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 972.4970414201183,
      "ty": 556.6863905325444,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 972.4970414201183,
      "y": 556.6863905325444,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 981.5857988165681,
      "ty": 543.0532544378698,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 981.5857988165681,
      "y": 543.0532544378698,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 974.7692307692307,
      "ty": 540.7810650887574,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 974.7692307692307,
      "y": 540.7810650887574,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 963.4082840236686,
      "ty": 543.0532544378698,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 963.4082840236686,
      "y": 543.0532544378698,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 961.1360946745561,
      "ty": 543.0532544378698,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 961.1360946745561,
      "y": 543.0532544378698,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 967.9526627218935,
      "ty": 522.603550295858,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }],
    "x": 0,
    "y": 0,
    "cx": 0,
    "cy": 0,
    "cx2": 0,
    "cy2": 0,
    "tx": 0,
    "ty": 0,
    "width": 0,
    "height": 0,
    "r": 0,
    "fill": false,
    "selected": false
  }, {
    "title": "沙树3",
    "desc": "沙树雷荣",
    "type": "polygon",
    "color": "red",
    "children": [{
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1092.923076923077,
      "y": 497.60946745562126,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1092.923076923077,
      "ty": 490.79289940828403,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1092.923076923077,
      "y": 490.79289940828403,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1152,
      "ty": 436.26035502958575,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1152,
      "y": 436.26035502958575,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1165.6331360946745,
      "ty": 449.8934911242604,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1165.6331360946745,
      "y": 449.8934911242604,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1179.2662721893491,
      "ty": 470.3431952662722,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1179.2662721893491,
      "y": 470.3431952662722,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1192.8994082840236,
      "ty": 493.06508875739644,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1192.8994082840236,
      "y": 493.06508875739644,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1204.2603550295858,
      "ty": 515.7869822485206,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1204.2603550295858,
      "y": 515.7869822485206,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1208.8047337278106,
      "ty": 527.1479289940828,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1208.8047337278106,
      "y": 527.1479289940828,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1197.4437869822484,
      "ty": 527.1479289940828,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1197.4437869822484,
      "y": 527.1479289940828,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1208.8047337278106,
      "ty": 545.3254437869822,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1208.8047337278106,
      "y": 545.3254437869822,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1213.3491124260354,
      "ty": 554.4142011834319,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1213.3491124260354,
      "y": 554.4142011834319,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1213.3491124260354,
      "ty": 563.5029585798816,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1213.3491124260354,
      "y": 563.5029585798816,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1211.076923076923,
      "ty": 570.3195266272189,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1211.076923076923,
      "y": 570.3195266272189,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1199.715976331361,
      "ty": 568.0473372781065,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1199.715976331361,
      "y": 568.0473372781065,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1199.715976331361,
      "ty": 579.4082840236687,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1199.715976331361,
      "y": 579.4082840236687,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1215.621301775148,
      "ty": 604.4023668639053,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1215.621301775148,
      "y": 604.4023668639053,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1213.3491124260354,
      "ty": 606.6745562130177,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1213.3491124260354,
      "y": 606.6745562130177,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1070.2011834319526,
      "ty": 615.7633136094674,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1070.2011834319526,
      "y": 615.7633136094674,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1077.01775147929,
      "ty": 602.1301775147929,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1077.01775147929,
      "y": 602.1301775147929,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1090.6508875739644,
      "ty": 583.9526627218935,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1090.6508875739644,
      "y": 583.9526627218935,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1095.1952662721892,
      "ty": 568.0473372781065,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1095.1952662721892,
      "y": 568.0473372781065,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1088.378698224852,
      "ty": 570.3195266272189,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1088.378698224852,
      "y": 570.3195266272189,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1090.6508875739644,
      "ty": 563.5029585798816,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1090.6508875739644,
      "y": 563.5029585798816,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1074.7455621301774,
      "ty": 561.2307692307692,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1074.7455621301774,
      "y": 561.2307692307692,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1077.01775147929,
      "ty": 552.1420118343195,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1077.01775147929,
      "y": 552.1420118343195,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1083.8343195266273,
      "ty": 540.7810650887574,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1083.8343195266273,
      "y": 540.7810650887574,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1099.7396449704142,
      "ty": 527.1479289940828,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1099.7396449704142,
      "y": 527.1479289940828,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1106.5562130177514,
      "ty": 515.7869822485206,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1106.5562130177514,
      "y": 515.7869822485206,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1095.1952662721892,
      "ty": 513.5147928994082,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1095.1952662721892,
      "y": 513.5147928994082,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1086.1065088757396,
      "ty": 515.7869822485206,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1086.1065088757396,
      "y": 515.7869822485206,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1092.923076923077,
      "ty": 497.60946745562126,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }],
    "x": 0,
    "y": 0,
    "cx": 0,
    "cy": 0,
    "cx2": 0,
    "cy2": 0,
    "tx": 0,
    "ty": 0,
    "width": 0,
    "height": 0,
    "r": 0,
    "fill": false,
    "selected": false
  }, {
    "title": "沙树4",
    "desc": "针叶树木",
    "type": "pen",
    "color": "red",
    "children": [{
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1701.869822485207,
      "y": 938.414201183432,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1708.6863905325445,
      "ty": 922.508875739645,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1708.6863905325445,
      "y": 922.508875739645,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1745.041420118343,
      "ty": 888.4260355029586,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 1745.041420118343,
      "y": 888.4260355029586,
      "cx": 1799.5739644970415,
      "cy": 833.8934911242603,
      "cx2": 0,
      "cy2": 0,
      "tx": 1799.5739644970415,
      "ty": 833.8934911242603,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1799.5739644970415,
      "y": 833.8934911242603,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1824.5680473372781,
      "ty": 811.1715976331361,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 1824.5680473372781,
      "y": 811.1715976331361,
      "cx": 1833.6568047337278,
      "cy": 804.3550295857988,
      "cx2": 0,
      "cy2": 0,
      "tx": 1833.6568047337278,
      "ty": 804.3550295857988,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1833.6568047337278,
      "y": 804.3550295857988,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1854.1065088757396,
      "ty": 817.9881656804733,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 1854.1065088757396,
      "y": 817.9881656804733,
      "cx": 1890.4615384615386,
      "cy": 874.792899408284,
      "cx2": 0,
      "cy2": 0,
      "tx": 1890.4615384615386,
      "ty": 874.792899408284,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 1890.4615384615386,
      "y": 874.792899408284,
      "cx": 1920,
      "cy": 904.3313609467456,
      "cx2": 0,
      "cy2": 0,
      "tx": 1920,
      "ty": 924.7810650887574,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1920,
      "y": 924.7810650887574,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1920,
      "ty": 1192.8994082840236,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1920,
      "y": 1192.8994082840236,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1654.1538461538462,
      "ty": 1192.8994082840236,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1654.1538461538462,
      "y": 1192.8994082840236,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1665.5147928994081,
      "ty": 1176.9940828402366,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 1665.5147928994081,
      "y": 1176.9940828402366,
      "cx": 1683.6923076923076,
      "cy": 1145.1834319526627,
      "cx2": 0,
      "cy2": 0,
      "tx": 1683.6923076923076,
      "ty": 1145.1834319526627,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 1683.6923076923076,
      "y": 1145.1834319526627,
      "cx": 1692.7810650887573,
      "cy": 1108.8284023668639,
      "cx2": 0,
      "cy2": 0,
      "tx": 1704.1420118343194,
      "ty": 1099.7396449704142,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1704.1420118343194,
      "y": 1099.7396449704142,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1688.2366863905324,
      "ty": 1102.0118343195265,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 1688.2366863905324,
      "y": 1102.0118343195265,
      "cx": 1695.05325443787,
      "cy": 1088.378698224852,
      "cx2": 0,
      "cy2": 0,
      "tx": 1695.05325443787,
      "ty": 1088.378698224852,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 1695.05325443787,
      "y": 1088.378698224852,
      "cx": 1663.2426035502958,
      "cy": 1090.6508875739644,
      "cx2": 0,
      "cy2": 0,
      "tx": 1658.698224852071,
      "ty": 1077.01775147929,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 1658.698224852071,
      "y": 1077.01775147929,
      "cx": 1667.7869822485206,
      "cy": 1045.207100591716,
      "cx2": 0,
      "cy2": 0,
      "tx": 1679.1479289940828,
      "ty": 1042.9349112426034,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 1679.1479289940828,
      "y": 1042.9349112426034,
      "cx": 1672.3313609467455,
      "cy": 1029.301775147929,
      "cx2": 0,
      "cy2": 0,
      "tx": 1713.230769230769,
      "ty": 1006.5798816568047,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1713.230769230769,
      "y": 1006.5798816568047,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1729.1360946745563,
      "ty": 986.1301775147929,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1729.1360946745563,
      "y": 986.1301775147929,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1731.4082840236686,
      "ty": 977.0414201183431,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1731.4082840236686,
      "y": 977.0414201183431,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1708.6863905325445,
      "ty": 974.7692307692307,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 1708.6863905325445,
      "y": 974.7692307692307,
      "cx": 1690.508875739645,
      "cy": 977.0414201183431,
      "cx2": 0,
      "cy2": 0,
      "tx": 1690.508875739645,
      "ty": 977.0414201183431,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1690.508875739645,
      "y": 977.0414201183431,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1688.2366863905324,
      "ty": 972.4970414201183,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1688.2366863905324,
      "y": 972.4970414201183,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1695.05325443787,
      "ty": 961.1360946745561,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 1695.05325443787,
      "y": 961.1360946745561,
      "cx": 1704.1420118343194,
      "cy": 945.2307692307693,
      "cx2": 0,
      "cy2": 0,
      "tx": 1704.1420118343194,
      "ty": 945.2307692307693,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1704.1420118343194,
      "y": 945.2307692307693,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1701.869822485207,
      "ty": 938.414201183432,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }],
    "x": 0,
    "y": 0,
    "cx": 0,
    "cy": 0,
    "cx2": 0,
    "cy2": 0,
    "tx": 0,
    "ty": 0,
    "width": 0,
    "height": 0,
    "r": 0,
    "fill": false,
    "selected": false
  }, {
    "title": "男子",
    "desc": "中年男子",
    "type": "pen",
    "color": "red",
    "children": [{
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 524.8757396449704,
      "y": 554.4142011834319,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 531.6923076923076,
      "ty": 549.8698224852071,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 531.6923076923076,
      "y": 549.8698224852071,
      "cx": 520.3313609467456,
      "cy": 533.9644970414201,
      "cx2": 0,
      "cy2": 0,
      "tx": 513.5147928994082,
      "ty": 508.9704142011834,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 513.5147928994082,
      "y": 508.9704142011834,
      "cx": 518.0591715976332,
      "cy": 502.1538461538461,
      "cx2": 0,
      "cy2": 0,
      "tx": 529.4201183431952,
      "ty": 513.5147928994082,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 529.4201183431952,
      "y": 513.5147928994082,
      "cx": 536.2366863905326,
      "cy": 474.887573964497,
      "cx2": 0,
      "cy2": 0,
      "tx": 554.4142011834319,
      "ty": 479.4319526627218,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 554.4142011834319,
      "y": 479.4319526627218,
      "cx": 583.9526627218935,
      "cy": 481.7041420118343,
      "cx2": 0,
      "cy2": 0,
      "tx": 579.4082840236687,
      "ty": 533.9644970414201,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 579.4082840236687,
      "y": 533.9644970414201,
      "cx": 583.9526627218935,
      "cy": 536.2366863905326,
      "cx2": 0,
      "cy2": 0,
      "tx": 583.9526627218935,
      "ty": 536.2366863905326,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 583.9526627218935,
      "y": 536.2366863905326,
      "cx": 597.5857988165681,
      "cy": 629.396449704142,
      "cx2": 0,
      "cy2": 0,
      "tx": 643.0295857988166,
      "ty": 674.8402366863905,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 643.0295857988166,
      "y": 674.8402366863905,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 645.301775147929,
      "ty": 661.207100591716,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 645.301775147929,
      "y": 661.207100591716,
      "cx": 608.9467455621301,
      "cy": 604.4023668639053,
      "cx2": 0,
      "cy2": 0,
      "tx": 638.4852071005917,
      "ty": 565.7751479289941,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 638.4852071005917,
      "y": 565.7751479289941,
      "cx": 658.9349112426037,
      "cy": 518.0591715976332,
      "cx2": 0,
      "cy2": 0,
      "tx": 672.5680473372781,
      "ty": 518.0591715976332,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 672.5680473372781,
      "y": 518.0591715976332,
      "cx": 674.8402366863905,
      "cy": 513.5147928994082,
      "cx2": 0,
      "cy2": 0,
      "tx": 674.8402366863905,
      "ty": 513.5147928994082,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 674.8402366863905,
      "y": 513.5147928994082,
      "cx": 658.9349112426037,
      "cy": 513.5147928994082,
      "cx2": 0,
      "cy2": 0,
      "tx": 663.4792899408284,
      "ty": 495.3372781065089,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 663.4792899408284,
      "y": 495.3372781065089,
      "cx": 715.7396449704141,
      "cy": 452.1656804733728,
      "cx2": 0,
      "cy2": 0,
      "tx": 745.2781065088757,
      "ty": 463.5266272189349,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 745.2781065088757,
      "y": 463.5266272189349,
      "cx": 740.7337278106509,
      "cy": 458.98224852071,
      "cx2": 0,
      "cy2": 0,
      "tx": 743.0059171597633,
      "ty": 454.4378698224852,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 743.0059171597633,
      "y": 454.4378698224852,
      "cx": 747.5502958579881,
      "cy": 447.6213017751479,
      "cx2": 0,
      "cy2": 0,
      "tx": 752.094674556213,
      "ty": 449.8934911242604,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 752.094674556213,
      "y": 449.8934911242604,
      "cx": 772.5443786982248,
      "cy": 461.2544378698225,
      "cx2": 0,
      "cy2": 0,
      "tx": 774.8165680473372,
      "ty": 465.7988165680473,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 774.8165680473372,
      "y": 465.7988165680473,
      "cx": 822.532544378698,
      "cy": 470.3431952662722,
      "cx2": 0,
      "cy2": 0,
      "tx": 824.8047337278106,
      "ty": 483.97633136094674,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 824.8047337278106,
      "y": 483.97633136094674,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 817.9881656804733,
      "ty": 488.52071005917156,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 817.9881656804733,
      "y": 488.52071005917156,
      "cx": 902.059171597633,
      "cy": 524.8757396449704,
      "cx2": 0,
      "cy2": 0,
      "tx": 861.1597633136093,
      "ty": 618.0355029585799,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 861.1597633136093,
      "y": 618.0355029585799,
      "cx": 856.6153846153845,
      "cy": 640.757396449704,
      "cx2": 0,
      "cy2": 0,
      "tx": 856.6153846153845,
      "ty": 640.757396449704,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 856.6153846153845,
      "y": 640.757396449704,
      "cx": 883.8816568047337,
      "cy": 693.0177514792899,
      "cx2": 0,
      "cy2": 0,
      "tx": 870.2485207100591,
      "ty": 729.3727810650887,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 870.2485207100591,
      "y": 729.3727810650887,
      "cx": 847.526627218935,
      "cy": 781.6331360946746,
      "cx2": 0,
      "cy2": 0,
      "tx": 783.905325443787,
      "ty": 781.6331360946746,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 783.905325443787,
      "y": 781.6331360946746,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 781.6331360946746,
      "ty": 902.059171597633,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 781.6331360946746,
      "y": 902.059171597633,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 770.2721893491123,
      "ty": 908.8757396449704,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 770.2721893491123,
      "y": 908.8757396449704,
      "cx": 761.1834319526627,
      "cy": 956.5917159763313,
      "cx2": 0,
      "cy2": 0,
      "tx": 781.6331360946746,
      "ty": 947.5029585798816,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 781.6331360946746,
      "y": 947.5029585798816,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 820.2603550295858,
      "ty": 940.6863905325444,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 820.2603550295858,
      "y": 940.6863905325444,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 824.8047337278106,
      "ty": 947.5029585798816,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 824.8047337278106,
      "y": 947.5029585798816,
      "cx": 824.8047337278106,
      "cy": 949.775147928994,
      "cx2": 0,
      "cy2": 0,
      "tx": 824.8047337278106,
      "ty": 949.775147928994,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 824.8047337278106,
      "y": 949.775147928994,
      "cx": 847.526627218935,
      "cy": 936.1420118343195,
      "cx2": 0,
      "cy2": 0,
      "tx": 856.6153846153845,
      "ty": 940.6863905325444,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 856.6153846153845,
      "y": 940.6863905325444,
      "cx": 890.698224852071,
      "cy": 924.7810650887574,
      "cx2": 0,
      "cy2": 0,
      "tx": 897.5147928994082,
      "ty": 961.1360946745561,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 897.5147928994082,
      "y": 961.1360946745561,
      "cx": 906.6035502958579,
      "cy": 1031.5739644970413,
      "cx2": 0,
      "cy2": 0,
      "tx": 886.1538461538461,
      "ty": 1033.8461538461538,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 886.1538461538461,
      "y": 1033.8461538461538,
      "cx": 867.9763313609466,
      "cy": 999.7633136094674,
      "cx2": 0,
      "cy2": 0,
      "tx": 831.6213017751479,
      "ty": 1002.0355029585799,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 831.6213017751479,
      "y": 1002.0355029585799,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 829.3491124260355,
      "ty": 1008.8520710059171,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 829.3491124260355,
      "y": 1008.8520710059171,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 765.7278106508876,
      "ty": 1006.5798816568047,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 765.7278106508876,
      "y": 1006.5798816568047,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 743.0059171597633,
      "ty": 1008.8520710059171,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 743.0059171597633,
      "y": 1008.8520710059171,
      "cx": 695.2899408284023,
      "cy": 986.1301775147929,
      "cx2": 0,
      "cy2": 0,
      "tx": 683.9289940828402,
      "ty": 967.9526627218935,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 683.9289940828402,
      "y": 967.9526627218935,
      "cx": 622.5798816568047,
      "cy": 904.3313609467456,
      "cx2": 0,
      "cy2": 0,
      "tx": 622.5798816568047,
      "ty": 904.3313609467456,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 622.5798816568047,
      "y": 904.3313609467456,
      "cx": 604.4023668639053,
      "cy": 888.4260355029586,
      "cx2": 0,
      "cy2": 0,
      "tx": 579.4082840236687,
      "ty": 942.9585798816568,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 579.4082840236687,
      "y": 942.9585798816568,
      "cx": 570.3195266272189,
      "cy": 936.1420118343195,
      "cx2": 0,
      "cy2": 0,
      "tx": 570.3195266272189,
      "ty": 936.1420118343195,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 570.3195266272189,
      "y": 936.1420118343195,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 561.2307692307692,
      "ty": 949.775147928994,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 561.2307692307692,
      "y": 949.775147928994,
      "cx": 545.3254437869822,
      "cy": 977.0414201183431,
      "cx2": 0,
      "cy2": 0,
      "tx": 540.7810650887574,
      "ty": 979.3136094674555,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 540.7810650887574,
      "y": 979.3136094674555,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 524.8757396449704,
      "ty": 979.3136094674555,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 524.8757396449704,
      "y": 979.3136094674555,
      "cx": 472.61538461538464,
      "cy": 954.3195266272189,
      "cx2": 0,
      "cy2": 0,
      "tx": 479.4319526627218,
      "ty": 922.508875739645,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 479.4319526627218,
      "y": 922.508875739645,
      "cx": 479.4319526627218,
      "cy": 911.1479289940828,
      "cx2": 0,
      "cy2": 0,
      "tx": 522.603550295858,
      "ty": 911.1479289940828,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 522.603550295858,
      "y": 911.1479289940828,
      "cx": 529.4201183431952,
      "cy": 906.6035502958579,
      "cx2": 0,
      "cy2": 0,
      "tx": 529.4201183431952,
      "ty": 906.6035502958579,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 529.4201183431952,
      "y": 906.6035502958579,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 536.2366863905326,
      "ty": 892.9704142011835,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 536.2366863905326,
      "y": 892.9704142011835,
      "cx": 538.508875739645,
      "cy": 892.9704142011835,
      "cx2": 0,
      "cy2": 0,
      "tx": 538.508875739645,
      "ty": 892.9704142011835,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 538.508875739645,
      "y": 892.9704142011835,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 536.2366863905326,
      "ty": 886.1538461538461,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 536.2366863905326,
      "y": 886.1538461538461,
      "cx": 574.8639053254437,
      "cy": 827.0769230769231,
      "cx2": 0,
      "cy2": 0,
      "tx": 597.5857988165681,
      "ty": 833.8934911242603,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 597.5857988165681,
      "y": 833.8934911242603,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 599.8579881656805,
      "ty": 831.6213017751479,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 599.8579881656805,
      "y": 831.6213017751479,
      "cx": 611.2189349112426,
      "cy": 797.5384615384615,
      "cx2": 0,
      "cy2": 0,
      "tx": 631.6686390532544,
      "ty": 736.189349112426,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 631.6686390532544,
      "y": 736.189349112426,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 588.4970414201183,
      "ty": 681.6568047337278,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 588.4970414201183,
      "y": 681.6568047337278,
      "cx": 568.0473372781065,
      "cy": 640.757396449704,
      "cx2": 0,
      "cy2": 0,
      "tx": 568.0473372781065,
      "ty": 640.757396449704,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 568.0473372781065,
      "y": 640.757396449704,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 524.8757396449704,
      "ty": 554.4142011834319,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 524.8757396449704,
      "y": 554.4142011834319,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 524.8757396449704,
      "ty": 554.4142011834319,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }],
    "x": 0,
    "y": 0,
    "cx": 0,
    "cy": 0,
    "cx2": 0,
    "cy2": 0,
    "tx": 0,
    "ty": 0,
    "width": 0,
    "height": 0,
    "r": 0,
    "fill": false,
    "selected": false
  }, {
    "title": "",
    "desc": "",
    "type": "pen",
    "color": "red",
    "children": [{
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 806.6272189349112,
      "y": 702.1065088757396,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 827.0769230769231,
      "ty": 693.0177514792899,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 827.0769230769231,
      "y": 693.0177514792899,
      "cx": 833.8934911242603,
      "cy": 736.189349112426,
      "cx2": 0,
      "cy2": 0,
      "tx": 786.1775147928994,
      "ty": 736.189349112426,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "curve",
      "color": "red",
      "children": [],
      "x": 786.1775147928994,
      "y": 736.189349112426,
      "cx": 808.8994082840237,
      "cy": 711.1952662721894,
      "cx2": 0,
      "cy2": 0,
      "tx": 806.6272189349112,
      "ty": 704.3786982248522,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 806.6272189349112,
      "y": 704.3786982248522,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 806.6272189349112,
      "ty": 702.1065088757396,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }],
    "x": 0,
    "y": 0,
    "cx": 0,
    "cy": 0,
    "cx2": 0,
    "cy2": 0,
    "tx": 0,
    "ty": 0,
    "width": 0,
    "height": 0,
    "r": 0,
    "fill": false,
    "selected": false
  }, {
    "title": "女子",
    "desc": "中年女子",
    "type": "lasso",
    "color": "red",
    "children": [{
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1454.2011834319526,
      "y": 215.85798816568047,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1458.7455621301774,
      "ty": 215.85798816568047,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1458.7455621301774,
      "y": 215.85798816568047,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1463.289940828402,
      "ty": 213.58579881656806,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1463.289940828402,
      "y": 213.58579881656806,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1467.8343195266273,
      "ty": 213.58579881656806,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1467.8343195266273,
      "y": 213.58579881656806,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1472.378698224852,
      "ty": 213.58579881656806,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1472.378698224852,
      "y": 213.58579881656806,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1476.923076923077,
      "ty": 215.85798816568047,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1476.923076923077,
      "y": 215.85798816568047,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1481.4674556213017,
      "ty": 215.85798816568047,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1481.4674556213017,
      "y": 215.85798816568047,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1486.0118343195265,
      "ty": 215.85798816568047,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1486.0118343195265,
      "y": 215.85798816568047,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1490.5562130177514,
      "ty": 218.13017751479288,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1490.5562130177514,
      "y": 218.13017751479288,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1495.1005917159762,
      "ty": 218.13017751479288,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1495.1005917159762,
      "y": 218.13017751479288,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1499.6449704142015,
      "ty": 218.13017751479288,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1499.6449704142015,
      "y": 218.13017751479288,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1504.189349112426,
      "ty": 220.4023668639053,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1504.189349112426,
      "y": 220.4023668639053,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1508.7337278106509,
      "ty": 224.9467455621302,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1508.7337278106509,
      "y": 224.9467455621302,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1513.278106508876,
      "ty": 227.2189349112426,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1513.278106508876,
      "y": 227.2189349112426,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1515.5502958579882,
      "ty": 231.76331360946745,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1515.5502958579882,
      "y": 231.76331360946745,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1520.0946745562128,
      "ty": 236.30769230769232,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1520.0946745562128,
      "y": 236.30769230769232,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1524.6390532544378,
      "ty": 240.85207100591714,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1524.6390532544378,
      "y": 240.85207100591714,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1526.9112426035504,
      "ty": 245.39644970414201,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1526.9112426035504,
      "y": 245.39644970414201,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1531.4556213017752,
      "ty": 249.94082840236686,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1531.4556213017752,
      "y": 249.94082840236686,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1533.7278106508877,
      "ty": 254.4852071005917,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1533.7278106508877,
      "y": 254.4852071005917,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1536,
      "ty": 259.0295857988166,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1536,
      "y": 259.0295857988166,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1540.5443786982246,
      "ty": 263.5739644970414,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1540.5443786982246,
      "y": 263.5739644970414,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1540.5443786982246,
      "ty": 268.1183431952663,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1540.5443786982246,
      "y": 268.1183431952663,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1542.8165680473371,
      "ty": 272.6627218934911,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1542.8165680473371,
      "y": 272.6627218934911,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1545.0887573964496,
      "ty": 277.20710059171597,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1545.0887573964496,
      "y": 277.20710059171597,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1545.0887573964496,
      "ty": 281.7514792899408,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1545.0887573964496,
      "y": 281.7514792899408,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1545.0887573964496,
      "ty": 286.29585798816566,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1545.0887573964496,
      "y": 286.29585798816566,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1547.3609467455622,
      "ty": 290.84023668639054,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1547.3609467455622,
      "y": 290.84023668639054,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1547.3609467455622,
      "ty": 295.38461538461536,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1547.3609467455622,
      "y": 295.38461538461536,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1547.3609467455622,
      "ty": 299.92899408284023,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1547.3609467455622,
      "y": 299.92899408284023,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1547.3609467455622,
      "ty": 304.47337278106505,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1547.3609467455622,
      "y": 304.47337278106505,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1547.3609467455622,
      "ty": 309.0177514792899,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1547.3609467455622,
      "y": 309.0177514792899,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1547.3609467455622,
      "ty": 313.5621301775148,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1547.3609467455622,
      "y": 313.5621301775148,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1547.3609467455622,
      "ty": 318.1065088757396,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1547.3609467455622,
      "y": 318.1065088757396,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1547.3609467455622,
      "ty": 322.6508875739645,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1547.3609467455622,
      "y": 322.6508875739645,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1547.3609467455622,
      "ty": 327.1952662721893,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1547.3609467455622,
      "y": 327.1952662721893,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1547.3609467455622,
      "ty": 331.7396449704142,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1547.3609467455622,
      "y": 331.7396449704142,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1547.3609467455622,
      "ty": 338.5562130177515,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1547.3609467455622,
      "y": 338.5562130177515,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1547.3609467455622,
      "ty": 343.10059171597624,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1547.3609467455622,
      "y": 343.10059171597624,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1547.3609467455622,
      "ty": 347.64497041420117,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1547.3609467455622,
      "y": 347.64497041420117,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1547.3609467455622,
      "ty": 352.1893491124261,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1547.3609467455622,
      "y": 352.1893491124261,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1547.3609467455622,
      "ty": 356.73372781065086,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1547.3609467455622,
      "y": 356.73372781065086,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1547.3609467455622,
      "ty": 361.27810650887574,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1547.3609467455622,
      "y": 361.27810650887574,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1549.6331360946745,
      "ty": 365.8224852071005,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1549.6331360946745,
      "y": 365.8224852071005,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1549.6331360946745,
      "ty": 370.36686390532543,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1549.6331360946745,
      "y": 370.36686390532543,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1549.6331360946745,
      "ty": 374.91124260355036,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1549.6331360946745,
      "y": 374.91124260355036,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1549.6331360946745,
      "ty": 379.4556213017751,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1549.6331360946745,
      "y": 379.4556213017751,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1549.6331360946745,
      "ty": 384,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1549.6331360946745,
      "y": 384,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1547.3609467455622,
      "ty": 388.54437869822476,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1547.3609467455622,
      "y": 388.54437869822476,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1547.3609467455622,
      "ty": 393.0887573964497,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1547.3609467455622,
      "y": 393.0887573964497,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1547.3609467455622,
      "ty": 397.6331360946745,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1547.3609467455622,
      "y": 397.6331360946745,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1547.3609467455622,
      "ty": 402.1775147928994,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1547.3609467455622,
      "y": 402.1775147928994,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1547.3609467455622,
      "ty": 406.72189349112426,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1547.3609467455622,
      "y": 406.72189349112426,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1547.3609467455622,
      "ty": 411.266272189349,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1547.3609467455622,
      "y": 411.266272189349,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1549.6331360946745,
      "ty": 415.81065088757396,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1549.6331360946745,
      "y": 415.81065088757396,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1554.177514792899,
      "ty": 418.08284023668637,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1554.177514792899,
      "y": 418.08284023668637,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1558.721893491124,
      "ty": 418.08284023668637,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1558.721893491124,
      "y": 418.08284023668637,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1563.2662721893491,
      "ty": 418.08284023668637,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1563.2662721893491,
      "y": 418.08284023668637,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1567.810650887574,
      "ty": 418.08284023668637,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1567.810650887574,
      "y": 418.08284023668637,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1572.3550295857988,
      "ty": 418.08284023668637,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1572.3550295857988,
      "y": 418.08284023668637,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1576.8994082840236,
      "ty": 415.81065088757396,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1576.8994082840236,
      "y": 415.81065088757396,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1581.4437869822484,
      "ty": 415.81065088757396,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1581.4437869822484,
      "y": 415.81065088757396,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1585.9881656804732,
      "ty": 413.53846153846155,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1585.9881656804732,
      "y": 413.53846153846155,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1590.532544378698,
      "ty": 413.53846153846155,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1590.532544378698,
      "y": 413.53846153846155,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1595.076923076923,
      "ty": 413.53846153846155,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1595.076923076923,
      "y": 413.53846153846155,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1599.621301775148,
      "ty": 413.53846153846155,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1599.621301775148,
      "y": 413.53846153846155,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1604.165680473373,
      "ty": 415.81065088757396,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1604.165680473373,
      "y": 415.81065088757396,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1608.7100591715975,
      "ty": 415.81065088757396,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1608.7100591715975,
      "y": 415.81065088757396,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1613.2544378698224,
      "ty": 418.08284023668637,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1613.2544378698224,
      "y": 418.08284023668637,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1615.526627218935,
      "ty": 422.62721893491124,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1615.526627218935,
      "y": 422.62721893491124,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1620.0710059171597,
      "ty": 427.1715976331361,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1620.0710059171597,
      "y": 427.1715976331361,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1620.0710059171597,
      "ty": 431.71597633136093,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1620.0710059171597,
      "y": 431.71597633136093,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1620.0710059171597,
      "ty": 436.26035502958575,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1620.0710059171597,
      "y": 436.26035502958575,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1620.0710059171597,
      "ty": 440.8047337278106,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1620.0710059171597,
      "y": 440.8047337278106,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1620.0710059171597,
      "ty": 445.3491124260355,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1620.0710059171597,
      "y": 445.3491124260355,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1620.0710059171597,
      "ty": 449.8934911242604,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1620.0710059171597,
      "y": 449.8934911242604,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1617.7988165680474,
      "ty": 454.4378698224852,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1617.7988165680474,
      "y": 454.4378698224852,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1613.2544378698224,
      "ty": 454.4378698224852,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1613.2544378698224,
      "y": 454.4378698224852,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1608.7100591715975,
      "ty": 454.4378698224852,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1608.7100591715975,
      "y": 454.4378698224852,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1604.165680473373,
      "ty": 456.71005917159755,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1604.165680473373,
      "y": 456.71005917159755,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1599.621301775148,
      "ty": 456.71005917159755,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1599.621301775148,
      "y": 456.71005917159755,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1595.076923076923,
      "ty": 456.71005917159755,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1595.076923076923,
      "y": 456.71005917159755,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1590.532544378698,
      "ty": 456.71005917159755,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1590.532544378698,
      "y": 456.71005917159755,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1585.9881656804732,
      "ty": 458.98224852071,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1585.9881656804732,
      "y": 458.98224852071,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1581.4437869822484,
      "ty": 458.98224852071,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1581.4437869822484,
      "y": 458.98224852071,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1576.8994082840236,
      "ty": 461.2544378698225,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1576.8994082840236,
      "y": 461.2544378698225,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1572.3550295857988,
      "ty": 463.5266272189349,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1572.3550295857988,
      "y": 463.5266272189349,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1567.810650887574,
      "ty": 463.5266272189349,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1567.810650887574,
      "y": 463.5266272189349,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1563.2662721893491,
      "ty": 465.7988165680473,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1563.2662721893491,
      "y": 465.7988165680473,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1558.721893491124,
      "ty": 465.7988165680473,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1558.721893491124,
      "y": 465.7988165680473,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1554.177514792899,
      "ty": 465.7988165680473,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1554.177514792899,
      "y": 465.7988165680473,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1549.6331360946745,
      "ty": 468.07100591715977,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1549.6331360946745,
      "y": 468.07100591715977,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1545.0887573964496,
      "ty": 470.3431952662722,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1545.0887573964496,
      "y": 470.3431952662722,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1540.5443786982246,
      "ty": 472.61538461538464,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1540.5443786982246,
      "y": 472.61538461538464,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1536,
      "ty": 472.61538461538464,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1536,
      "y": 472.61538461538464,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1531.4556213017752,
      "ty": 474.887573964497,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1531.4556213017752,
      "y": 474.887573964497,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1526.9112426035504,
      "ty": 474.887573964497,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1526.9112426035504,
      "y": 474.887573964497,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1522.3668639053253,
      "ty": 477.15976331360946,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1522.3668639053253,
      "y": 477.15976331360946,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1517.8224852071005,
      "ty": 477.15976331360946,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1517.8224852071005,
      "y": 477.15976331360946,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1513.278106508876,
      "ty": 477.15976331360946,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1513.278106508876,
      "y": 477.15976331360946,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1508.7337278106509,
      "ty": 479.4319526627218,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1508.7337278106509,
      "y": 479.4319526627218,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1504.189349112426,
      "ty": 479.4319526627218,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1504.189349112426,
      "y": 479.4319526627218,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1499.6449704142015,
      "ty": 481.7041420118343,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1499.6449704142015,
      "y": 481.7041420118343,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1495.1005917159762,
      "ty": 483.97633136094674,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1495.1005917159762,
      "y": 483.97633136094674,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1495.1005917159762,
      "ty": 488.52071005917156,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1495.1005917159762,
      "y": 488.52071005917156,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1499.6449704142015,
      "ty": 490.79289940828403,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1499.6449704142015,
      "y": 490.79289940828403,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1501.9171597633135,
      "ty": 495.3372781065089,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1501.9171597633135,
      "y": 495.3372781065089,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1504.189349112426,
      "ty": 499.8816568047337,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1504.189349112426,
      "y": 499.8816568047337,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1506.4615384615383,
      "ty": 504.42603550295854,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1506.4615384615383,
      "y": 504.42603550295854,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1506.4615384615383,
      "ty": 508.9704142011834,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1506.4615384615383,
      "y": 508.9704142011834,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1506.4615384615383,
      "ty": 513.5147928994082,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1506.4615384615383,
      "y": 513.5147928994082,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1508.7337278106509,
      "ty": 518.0591715976332,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1508.7337278106509,
      "y": 518.0591715976332,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1508.7337278106509,
      "ty": 522.603550295858,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1508.7337278106509,
      "y": 522.603550295858,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1508.7337278106509,
      "ty": 527.1479289940828,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1508.7337278106509,
      "y": 527.1479289940828,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1506.4615384615383,
      "ty": 531.6923076923076,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1506.4615384615383,
      "y": 531.6923076923076,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1506.4615384615383,
      "ty": 536.2366863905326,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1506.4615384615383,
      "y": 536.2366863905326,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1506.4615384615383,
      "ty": 540.7810650887574,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1506.4615384615383,
      "y": 540.7810650887574,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1511.0059171597632,
      "ty": 545.3254437869822,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1511.0059171597632,
      "y": 545.3254437869822,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1515.5502958579882,
      "ty": 549.8698224852071,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1515.5502958579882,
      "y": 549.8698224852071,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1517.8224852071005,
      "ty": 554.4142011834319,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1517.8224852071005,
      "y": 554.4142011834319,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1520.0946745562128,
      "ty": 558.9585798816568,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1520.0946745562128,
      "y": 558.9585798816568,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1522.3668639053253,
      "ty": 563.5029585798816,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1522.3668639053253,
      "y": 563.5029585798816,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1524.6390532544378,
      "ty": 568.0473372781065,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1524.6390532544378,
      "y": 568.0473372781065,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1524.6390532544378,
      "ty": 572.5917159763313,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1524.6390532544378,
      "y": 572.5917159763313,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1526.9112426035504,
      "ty": 577.1360946745561,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1526.9112426035504,
      "y": 577.1360946745561,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1529.1834319526627,
      "ty": 581.6804733727811,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1529.1834319526627,
      "y": 581.6804733727811,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1533.7278106508877,
      "ty": 586.2248520710059,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1533.7278106508877,
      "y": 586.2248520710059,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1538.2721893491123,
      "ty": 588.4970414201183,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1538.2721893491123,
      "y": 588.4970414201183,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1542.8165680473371,
      "ty": 590.7692307692307,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1542.8165680473371,
      "y": 590.7692307692307,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1545.0887573964496,
      "ty": 595.3136094674556,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1545.0887573964496,
      "y": 595.3136094674556,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1547.3609467455622,
      "ty": 599.8579881656805,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1547.3609467455622,
      "y": 599.8579881656805,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1551.905325443787,
      "ty": 604.4023668639053,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1551.905325443787,
      "y": 604.4023668639053,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1554.177514792899,
      "ty": 608.9467455621301,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1554.177514792899,
      "y": 608.9467455621301,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1554.177514792899,
      "ty": 613.491124260355,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1554.177514792899,
      "y": 613.491124260355,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1554.177514792899,
      "ty": 618.0355029585799,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1554.177514792899,
      "y": 618.0355029585799,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1558.721893491124,
      "ty": 622.5798816568047,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1558.721893491124,
      "y": 622.5798816568047,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1563.2662721893491,
      "ty": 622.5798816568047,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1563.2662721893491,
      "y": 622.5798816568047,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1567.810650887574,
      "ty": 620.3076923076923,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1567.810650887574,
      "y": 620.3076923076923,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1570.0828402366863,
      "ty": 624.8520710059171,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1570.0828402366863,
      "y": 624.8520710059171,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1570.0828402366863,
      "ty": 629.396449704142,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1570.0828402366863,
      "y": 629.396449704142,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1574.627218934911,
      "ty": 629.396449704142,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1574.627218934911,
      "y": 629.396449704142,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1579.1715976331361,
      "ty": 629.396449704142,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1579.1715976331361,
      "y": 629.396449704142,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1583.7159763313612,
      "ty": 629.396449704142,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1583.7159763313612,
      "y": 629.396449704142,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1588.2603550295858,
      "ty": 629.396449704142,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1588.2603550295858,
      "y": 629.396449704142,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1592.8047337278106,
      "ty": 631.6686390532544,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1592.8047337278106,
      "y": 631.6686390532544,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1597.3491124260354,
      "ty": 629.396449704142,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1597.3491124260354,
      "y": 629.396449704142,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1599.621301775148,
      "ty": 633.9408284023667,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1599.621301775148,
      "y": 633.9408284023667,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1604.165680473373,
      "ty": 638.4852071005917,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1604.165680473373,
      "y": 638.4852071005917,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1604.165680473373,
      "ty": 643.0295857988166,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1604.165680473373,
      "y": 643.0295857988166,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1606.437869822485,
      "ty": 647.5739644970414,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1606.437869822485,
      "y": 647.5739644970414,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1606.437869822485,
      "ty": 652.1183431952662,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1606.437869822485,
      "y": 652.1183431952662,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1606.437869822485,
      "ty": 656.6627218934912,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1606.437869822485,
      "y": 656.6627218934912,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1606.437869822485,
      "ty": 661.207100591716,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1606.437869822485,
      "y": 661.207100591716,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1606.437869822485,
      "ty": 665.7514792899409,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1606.437869822485,
      "y": 665.7514792899409,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1606.437869822485,
      "ty": 670.2958579881656,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1606.437869822485,
      "y": 670.2958579881656,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1608.7100591715975,
      "ty": 674.8402366863905,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1608.7100591715975,
      "y": 674.8402366863905,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1608.7100591715975,
      "ty": 679.3846153846152,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1608.7100591715975,
      "y": 679.3846153846152,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1608.7100591715975,
      "ty": 683.9289940828402,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1608.7100591715975,
      "y": 683.9289940828402,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1606.437869822485,
      "ty": 688.4733727810651,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1606.437869822485,
      "y": 688.4733727810651,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1601.8934911242602,
      "ty": 686.2011834319525,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1601.8934911242602,
      "y": 686.2011834319525,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1597.3491124260354,
      "ty": 683.9289940828402,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1597.3491124260354,
      "y": 683.9289940828402,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1595.076923076923,
      "ty": 679.3846153846152,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1595.076923076923,
      "y": 679.3846153846152,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1590.532544378698,
      "ty": 674.8402366863905,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1590.532544378698,
      "y": 674.8402366863905,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1585.9881656804732,
      "ty": 672.5680473372781,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1585.9881656804732,
      "y": 672.5680473372781,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1581.4437869822484,
      "ty": 668.0236686390532,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1581.4437869822484,
      "y": 668.0236686390532,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1579.1715976331361,
      "ty": 663.4792899408284,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1579.1715976331361,
      "y": 663.4792899408284,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1574.627218934911,
      "ty": 663.4792899408284,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1574.627218934911,
      "y": 663.4792899408284,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1572.3550295857988,
      "ty": 668.0236686390532,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1572.3550295857988,
      "y": 668.0236686390532,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1572.3550295857988,
      "ty": 672.5680473372781,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1572.3550295857988,
      "y": 672.5680473372781,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1567.810650887574,
      "ty": 674.8402366863905,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1567.810650887574,
      "y": 674.8402366863905,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1563.2662721893491,
      "ty": 674.8402366863905,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1563.2662721893491,
      "y": 674.8402366863905,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1558.721893491124,
      "ty": 674.8402366863905,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1558.721893491124,
      "y": 674.8402366863905,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1554.177514792899,
      "ty": 674.8402366863905,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1554.177514792899,
      "y": 674.8402366863905,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1549.6331360946745,
      "ty": 672.5680473372781,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1549.6331360946745,
      "y": 672.5680473372781,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1545.0887573964496,
      "ty": 672.5680473372781,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1545.0887573964496,
      "y": 672.5680473372781,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1540.5443786982246,
      "ty": 672.5680473372781,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1540.5443786982246,
      "y": 672.5680473372781,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1536,
      "ty": 672.5680473372781,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1536,
      "y": 672.5680473372781,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1531.4556213017752,
      "ty": 672.5680473372781,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1531.4556213017752,
      "y": 672.5680473372781,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1526.9112426035504,
      "ty": 672.5680473372781,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1526.9112426035504,
      "y": 672.5680473372781,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1522.3668639053253,
      "ty": 672.5680473372781,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1522.3668639053253,
      "y": 672.5680473372781,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1517.8224852071005,
      "ty": 670.2958579881656,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1517.8224852071005,
      "y": 670.2958579881656,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1513.278106508876,
      "ty": 670.2958579881656,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1513.278106508876,
      "y": 670.2958579881656,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1508.7337278106509,
      "ty": 668.0236686390532,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1508.7337278106509,
      "y": 668.0236686390532,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1504.189349112426,
      "ty": 665.7514792899409,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1504.189349112426,
      "y": 665.7514792899409,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1501.9171597633135,
      "ty": 661.207100591716,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1501.9171597633135,
      "y": 661.207100591716,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1497.3727810650887,
      "ty": 661.207100591716,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1497.3727810650887,
      "y": 661.207100591716,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1492.8284023668639,
      "ty": 663.4792899408284,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1492.8284023668639,
      "y": 663.4792899408284,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1488.284023668639,
      "ty": 663.4792899408284,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1488.284023668639,
      "y": 663.4792899408284,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1483.7396449704142,
      "ty": 663.4792899408284,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1483.7396449704142,
      "y": 663.4792899408284,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1479.1952662721892,
      "ty": 665.7514792899409,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1479.1952662721892,
      "y": 665.7514792899409,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1474.6508875739644,
      "ty": 668.0236686390532,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1474.6508875739644,
      "y": 668.0236686390532,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1470.1065088757396,
      "ty": 668.0236686390532,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1470.1065088757396,
      "y": 668.0236686390532,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1465.5621301775147,
      "ty": 670.2958579881656,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1465.5621301775147,
      "y": 670.2958579881656,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1461.01775147929,
      "ty": 670.2958579881656,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1461.01775147929,
      "y": 670.2958579881656,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1456.473372781065,
      "ty": 670.2958579881656,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1456.473372781065,
      "y": 670.2958579881656,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1451.92899408284,
      "ty": 672.5680473372781,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1451.92899408284,
      "y": 672.5680473372781,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1447.3846153846152,
      "ty": 672.5680473372781,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1447.3846153846152,
      "y": 672.5680473372781,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1442.8402366863907,
      "ty": 672.5680473372781,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1442.8402366863907,
      "y": 672.5680473372781,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1438.2958579881656,
      "ty": 674.8402366863905,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1438.2958579881656,
      "y": 674.8402366863905,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1433.7514792899408,
      "ty": 677.112426035503,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1433.7514792899408,
      "y": 677.112426035503,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1429.2071005917157,
      "ty": 677.112426035503,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1429.2071005917157,
      "y": 677.112426035503,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1426.9349112426034,
      "ty": 681.6568047337278,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1426.9349112426034,
      "y": 681.6568047337278,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1426.9349112426034,
      "ty": 686.2011834319525,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1426.9349112426034,
      "y": 686.2011834319525,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1429.2071005917157,
      "ty": 690.7455621301775,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1429.2071005917157,
      "y": 690.7455621301775,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1429.2071005917157,
      "ty": 695.2899408284023,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1429.2071005917157,
      "y": 695.2899408284023,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1431.4792899408283,
      "ty": 699.8343195266272,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1431.4792899408283,
      "y": 699.8343195266272,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1433.7514792899408,
      "ty": 704.3786982248522,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1433.7514792899408,
      "y": 704.3786982248522,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1436.0236686390533,
      "ty": 708.9230769230769,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1436.0236686390533,
      "y": 708.9230769230769,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1438.2958579881656,
      "ty": 713.4674556213017,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1438.2958579881656,
      "y": 713.4674556213017,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1442.8402366863907,
      "ty": 718.0118343195267,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1442.8402366863907,
      "y": 718.0118343195267,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1447.3846153846152,
      "ty": 722.5562130177515,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1447.3846153846152,
      "y": 722.5562130177515,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1449.6568047337275,
      "ty": 727.1005917159763,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1449.6568047337275,
      "y": 727.1005917159763,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1449.6568047337275,
      "ty": 731.644970414201,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1449.6568047337275,
      "y": 731.644970414201,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1447.3846153846152,
      "ty": 736.189349112426,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1447.3846153846152,
      "y": 736.189349112426,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1449.6568047337275,
      "ty": 740.7337278106509,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1449.6568047337275,
      "y": 740.7337278106509,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1449.6568047337275,
      "ty": 745.2781065088757,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1449.6568047337275,
      "y": 745.2781065088757,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1454.2011834319526,
      "ty": 747.5502958579881,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1454.2011834319526,
      "y": 747.5502958579881,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1456.473372781065,
      "ty": 752.094674556213,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1456.473372781065,
      "y": 752.094674556213,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1458.7455621301774,
      "ty": 756.639053254438,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1458.7455621301774,
      "y": 756.639053254438,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1456.473372781065,
      "ty": 761.1834319526627,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1456.473372781065,
      "y": 761.1834319526627,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1451.92899408284,
      "ty": 765.7278106508876,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1451.92899408284,
      "y": 765.7278106508876,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1447.3846153846152,
      "ty": 770.2721893491123,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1447.3846153846152,
      "y": 770.2721893491123,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1442.8402366863907,
      "ty": 774.8165680473372,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1442.8402366863907,
      "y": 774.8165680473372,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1438.2958579881656,
      "ty": 777.0887573964495,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1438.2958579881656,
      "y": 777.0887573964495,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1433.7514792899408,
      "ty": 777.0887573964495,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1433.7514792899408,
      "y": 777.0887573964495,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1429.2071005917157,
      "ty": 781.6331360946746,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1429.2071005917157,
      "y": 781.6331360946746,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1424.6627218934912,
      "ty": 783.905325443787,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1424.6627218934912,
      "y": 783.905325443787,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1420.118343195266,
      "ty": 783.905325443787,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1420.118343195266,
      "y": 783.905325443787,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1415.5739644970413,
      "ty": 788.4497041420118,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1415.5739644970413,
      "y": 788.4497041420118,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1411.0295857988165,
      "ty": 788.4497041420118,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1411.0295857988165,
      "y": 788.4497041420118,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1406.4852071005917,
      "ty": 788.4497041420118,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1406.4852071005917,
      "y": 788.4497041420118,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1404.2130177514791,
      "ty": 783.905325443787,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1404.2130177514791,
      "y": 783.905325443787,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1404.2130177514791,
      "ty": 779.360946745562,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1404.2130177514791,
      "y": 779.360946745562,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1404.2130177514791,
      "ty": 774.8165680473372,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1404.2130177514791,
      "y": 774.8165680473372,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1406.4852071005917,
      "ty": 770.2721893491123,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1406.4852071005917,
      "y": 770.2721893491123,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1411.0295857988165,
      "ty": 765.7278106508876,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1411.0295857988165,
      "y": 765.7278106508876,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1413.301775147929,
      "ty": 761.1834319526627,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1413.301775147929,
      "y": 761.1834319526627,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1415.5739644970413,
      "ty": 756.639053254438,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1415.5739644970413,
      "y": 756.639053254438,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1417.8461538461538,
      "ty": 752.094674556213,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1417.8461538461538,
      "y": 752.094674556213,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1415.5739644970413,
      "ty": 747.5502958579881,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1415.5739644970413,
      "y": 747.5502958579881,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1415.5739644970413,
      "ty": 743.0059171597633,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1415.5739644970413,
      "y": 743.0059171597633,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1411.0295857988165,
      "ty": 743.0059171597633,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1411.0295857988165,
      "y": 743.0059171597633,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1406.4852071005917,
      "ty": 743.0059171597633,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1406.4852071005917,
      "y": 743.0059171597633,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1404.2130177514791,
      "ty": 738.4615384615385,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1404.2130177514791,
      "y": 738.4615384615385,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1404.2130177514791,
      "ty": 733.9171597633136,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1404.2130177514791,
      "y": 733.9171597633136,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1406.4852071005917,
      "ty": 729.3727810650887,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1406.4852071005917,
      "y": 729.3727810650887,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1406.4852071005917,
      "ty": 724.8284023668638,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1406.4852071005917,
      "y": 724.8284023668638,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1406.4852071005917,
      "ty": 720.2840236686391,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1406.4852071005917,
      "y": 720.2840236686391,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1406.4852071005917,
      "ty": 715.7396449704141,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1406.4852071005917,
      "y": 715.7396449704141,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1404.2130177514791,
      "ty": 711.1952662721894,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1404.2130177514791,
      "y": 711.1952662721894,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1401.9408284023668,
      "ty": 706.6508875739645,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1401.9408284023668,
      "y": 706.6508875739645,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1399.6686390532543,
      "ty": 702.1065088757396,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1399.6686390532543,
      "y": 702.1065088757396,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1397.396449704142,
      "ty": 697.5621301775147,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1397.396449704142,
      "y": 697.5621301775147,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1395.1242603550295,
      "ty": 693.0177514792899,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1395.1242603550295,
      "y": 693.0177514792899,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1395.1242603550295,
      "ty": 688.4733727810651,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1395.1242603550295,
      "y": 688.4733727810651,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1392.8520710059172,
      "ty": 683.9289940828402,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1392.8520710059172,
      "y": 683.9289940828402,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1388.3076923076922,
      "ty": 683.9289940828402,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1388.3076923076922,
      "y": 683.9289940828402,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1383.7633136094673,
      "ty": 683.9289940828402,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1383.7633136094673,
      "y": 683.9289940828402,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1379.2189349112425,
      "ty": 683.9289940828402,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1379.2189349112425,
      "y": 683.9289940828402,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1374.6745562130177,
      "ty": 683.9289940828402,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1374.6745562130177,
      "y": 683.9289940828402,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1370.1301775147929,
      "ty": 683.9289940828402,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1370.1301775147929,
      "y": 683.9289940828402,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1365.585798816568,
      "ty": 683.9289940828402,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1365.585798816568,
      "y": 683.9289940828402,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1361.0414201183432,
      "ty": 683.9289940828402,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1361.0414201183432,
      "y": 683.9289940828402,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1356.4970414201182,
      "ty": 683.9289940828402,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1356.4970414201182,
      "y": 683.9289940828402,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1351.9526627218936,
      "ty": 683.9289940828402,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1351.9526627218936,
      "y": 683.9289940828402,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1347.4082840236686,
      "ty": 681.6568047337278,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1347.4082840236686,
      "y": 681.6568047337278,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1342.8639053254437,
      "ty": 681.6568047337278,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1342.8639053254437,
      "y": 681.6568047337278,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1338.3195266272187,
      "ty": 679.3846153846152,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1338.3195266272187,
      "y": 679.3846153846152,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1336.0473372781064,
      "ty": 674.8402366863905,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1336.0473372781064,
      "y": 674.8402366863905,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1331.5029585798818,
      "ty": 670.2958579881656,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1331.5029585798818,
      "y": 670.2958579881656,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1331.5029585798818,
      "ty": 665.7514792899409,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1331.5029585798818,
      "y": 665.7514792899409,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1331.5029585798818,
      "ty": 661.207100591716,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1331.5029585798818,
      "y": 661.207100591716,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1329.2307692307693,
      "ty": 656.6627218934912,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1329.2307692307693,
      "y": 656.6627218934912,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1329.2307692307693,
      "ty": 652.1183431952662,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1329.2307692307693,
      "y": 652.1183431952662,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1331.5029585798818,
      "ty": 647.5739644970414,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1331.5029585798818,
      "y": 647.5739644970414,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1333.775147928994,
      "ty": 643.0295857988166,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1333.775147928994,
      "y": 643.0295857988166,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1336.0473372781064,
      "ty": 638.4852071005917,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1336.0473372781064,
      "y": 638.4852071005917,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1336.0473372781064,
      "ty": 633.9408284023667,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1336.0473372781064,
      "y": 633.9408284023667,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1338.3195266272187,
      "ty": 629.396449704142,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1338.3195266272187,
      "y": 629.396449704142,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1338.3195266272187,
      "ty": 624.8520710059171,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1338.3195266272187,
      "y": 624.8520710059171,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1338.3195266272187,
      "ty": 620.3076923076923,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1338.3195266272187,
      "y": 620.3076923076923,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1338.3195266272187,
      "ty": 615.7633136094674,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1338.3195266272187,
      "y": 615.7633136094674,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1338.3195266272187,
      "ty": 611.2189349112426,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1338.3195266272187,
      "y": 611.2189349112426,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1336.0473372781064,
      "ty": 606.6745562130177,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1336.0473372781064,
      "y": 606.6745562130177,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1336.0473372781064,
      "ty": 602.1301775147929,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1336.0473372781064,
      "y": 602.1301775147929,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1336.0473372781064,
      "ty": 597.5857988165681,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1336.0473372781064,
      "y": 597.5857988165681,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1333.775147928994,
      "ty": 593.0414201183431,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1333.775147928994,
      "y": 593.0414201183431,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1333.775147928994,
      "ty": 588.4970414201183,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1333.775147928994,
      "y": 588.4970414201183,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1331.5029585798818,
      "ty": 583.9526627218935,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1331.5029585798818,
      "y": 583.9526627218935,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1331.5029585798818,
      "ty": 579.4082840236687,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1331.5029585798818,
      "y": 579.4082840236687,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1331.5029585798818,
      "ty": 574.8639053254437,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1331.5029585798818,
      "y": 574.8639053254437,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1333.775147928994,
      "ty": 570.3195266272189,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1333.775147928994,
      "y": 570.3195266272189,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1329.2307692307693,
      "ty": 568.0473372781065,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1329.2307692307693,
      "y": 568.0473372781065,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1324.6863905325442,
      "ty": 565.7751479289941,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1324.6863905325442,
      "y": 565.7751479289941,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1320.1420118343194,
      "ty": 563.5029585798816,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1320.1420118343194,
      "y": 563.5029585798816,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1315.5976331360946,
      "ty": 558.9585798816568,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1315.5976331360946,
      "y": 558.9585798816568,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1311.0532544378698,
      "ty": 556.6863905325444,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1311.0532544378698,
      "y": 556.6863905325444,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1306.508875739645,
      "ty": 558.9585798816568,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1306.508875739645,
      "y": 558.9585798816568,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1301.9644970414201,
      "ty": 554.4142011834319,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1301.9644970414201,
      "y": 554.4142011834319,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1299.6923076923076,
      "ty": 549.8698224852071,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1299.6923076923076,
      "y": 549.8698224852071,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1297.420118343195,
      "ty": 545.3254437869822,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1297.420118343195,
      "y": 545.3254437869822,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1297.420118343195,
      "ty": 540.7810650887574,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1297.420118343195,
      "y": 540.7810650887574,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1295.1479289940828,
      "ty": 536.2366863905326,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1295.1479289940828,
      "y": 536.2366863905326,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1295.1479289940828,
      "ty": 531.6923076923076,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1295.1479289940828,
      "y": 531.6923076923076,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1295.1479289940828,
      "ty": 527.1479289940828,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1295.1479289940828,
      "y": 527.1479289940828,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1292.8757396449703,
      "ty": 522.603550295858,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1292.8757396449703,
      "y": 522.603550295858,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1292.8757396449703,
      "ty": 518.0591715976332,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1292.8757396449703,
      "y": 518.0591715976332,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1292.8757396449703,
      "ty": 513.5147928994082,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1292.8757396449703,
      "y": 513.5147928994082,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1290.603550295858,
      "ty": 508.9704142011834,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1290.603550295858,
      "y": 508.9704142011834,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1290.603550295858,
      "ty": 504.42603550295854,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1290.603550295858,
      "y": 504.42603550295854,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1290.603550295858,
      "ty": 499.8816568047337,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1290.603550295858,
      "y": 499.8816568047337,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1288.3313609467455,
      "ty": 495.3372781065089,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1288.3313609467455,
      "y": 495.3372781065089,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1288.3313609467455,
      "ty": 490.79289940828403,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1288.3313609467455,
      "y": 490.79289940828403,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1288.3313609467455,
      "ty": 486.24852071005915,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1288.3313609467455,
      "y": 486.24852071005915,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1288.3313609467455,
      "ty": 481.7041420118343,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1288.3313609467455,
      "y": 481.7041420118343,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1288.3313609467455,
      "ty": 477.15976331360946,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1288.3313609467455,
      "y": 477.15976331360946,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1288.3313609467455,
      "ty": 472.61538461538464,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1288.3313609467455,
      "y": 472.61538461538464,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1288.3313609467455,
      "ty": 468.07100591715977,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1288.3313609467455,
      "y": 468.07100591715977,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1288.3313609467455,
      "ty": 463.5266272189349,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1288.3313609467455,
      "y": 463.5266272189349,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1290.603550295858,
      "ty": 458.98224852071,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1290.603550295858,
      "y": 458.98224852071,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1295.1479289940828,
      "ty": 454.4378698224852,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1295.1479289940828,
      "y": 454.4378698224852,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1299.6923076923076,
      "ty": 452.1656804733728,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1299.6923076923076,
      "y": 452.1656804733728,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1304.2366863905324,
      "ty": 447.6213017751479,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1304.2366863905324,
      "y": 447.6213017751479,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1308.7810650887573,
      "ty": 445.3491124260355,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1308.7810650887573,
      "y": 445.3491124260355,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1313.3254437869823,
      "ty": 443.07692307692304,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1313.3254437869823,
      "y": 443.07692307692304,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1317.8698224852074,
      "ty": 438.5325443786982,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1317.8698224852074,
      "y": 438.5325443786982,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1317.8698224852074,
      "ty": 433.9881656804733,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1317.8698224852074,
      "y": 433.9881656804733,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1320.1420118343194,
      "ty": 429.4437869822485,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1320.1420118343194,
      "y": 429.4437869822485,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1322.414201183432,
      "ty": 424.89940828402365,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1322.414201183432,
      "y": 424.89940828402365,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1322.414201183432,
      "ty": 420.3550295857988,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1322.414201183432,
      "y": 420.3550295857988,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1322.414201183432,
      "ty": 415.81065088757396,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1322.414201183432,
      "y": 415.81065088757396,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1322.414201183432,
      "ty": 411.266272189349,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1322.414201183432,
      "y": 411.266272189349,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1322.414201183432,
      "ty": 406.72189349112426,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1322.414201183432,
      "y": 406.72189349112426,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1317.8698224852074,
      "ty": 404.44970414201185,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1317.8698224852074,
      "y": 404.44970414201185,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1313.3254437869823,
      "ty": 402.1775147928994,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1313.3254437869823,
      "y": 402.1775147928994,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1308.7810650887573,
      "ty": 399.905325443787,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1308.7810650887573,
      "y": 399.905325443787,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1304.2366863905324,
      "ty": 399.905325443787,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1304.2366863905324,
      "y": 399.905325443787,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1299.6923076923076,
      "ty": 395.3609467455621,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1299.6923076923076,
      "y": 395.3609467455621,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1295.1479289940828,
      "ty": 395.3609467455621,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1295.1479289940828,
      "y": 395.3609467455621,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1290.603550295858,
      "ty": 395.3609467455621,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1290.603550295858,
      "y": 395.3609467455621,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1286.0591715976332,
      "ty": 395.3609467455621,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1286.0591715976332,
      "y": 395.3609467455621,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1281.514792899408,
      "ty": 395.3609467455621,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1281.514792899408,
      "y": 395.3609467455621,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1276.9704142011833,
      "ty": 395.3609467455621,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1276.9704142011833,
      "y": 395.3609467455621,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1276.9704142011833,
      "ty": 390.8165680473373,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1276.9704142011833,
      "y": 390.8165680473373,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1276.9704142011833,
      "ty": 386.2721893491124,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1276.9704142011833,
      "y": 386.2721893491124,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1276.9704142011833,
      "ty": 381.7278106508876,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1276.9704142011833,
      "y": 381.7278106508876,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1279.2426035502958,
      "ty": 377.1834319526627,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1279.2426035502958,
      "y": 377.1834319526627,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1276.9704142011833,
      "ty": 372.63905325443784,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1276.9704142011833,
      "y": 372.63905325443784,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1272.4260355029585,
      "ty": 368.094674556213,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1272.4260355029585,
      "y": 368.094674556213,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1272.4260355029585,
      "ty": 363.55029585798815,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1272.4260355029585,
      "y": 363.55029585798815,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1274.698224852071,
      "ty": 359.0059171597633,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1274.698224852071,
      "y": 359.0059171597633,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1274.698224852071,
      "ty": 354.46153846153845,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1274.698224852071,
      "y": 354.46153846153845,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1274.698224852071,
      "ty": 349.9171597633136,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1274.698224852071,
      "y": 349.9171597633136,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1276.9704142011833,
      "ty": 345.37278106508876,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1276.9704142011833,
      "y": 345.37278106508876,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1281.514792899408,
      "ty": 343.10059171597624,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1281.514792899408,
      "y": 343.10059171597624,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1283.7869822485206,
      "ty": 338.5562130177515,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1283.7869822485206,
      "y": 338.5562130177515,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1286.0591715976332,
      "ty": 334.0118343195266,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1286.0591715976332,
      "y": 334.0118343195266,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1288.3313609467455,
      "ty": 329.46745562130184,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1288.3313609467455,
      "y": 329.46745562130184,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1290.603550295858,
      "ty": 324.9230769230769,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1290.603550295858,
      "y": 324.9230769230769,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1292.8757396449703,
      "ty": 320.378698224852,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1292.8757396449703,
      "y": 320.378698224852,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1297.420118343195,
      "ty": 318.1065088757396,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1297.420118343195,
      "y": 318.1065088757396,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1299.6923076923076,
      "ty": 313.5621301775148,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1299.6923076923076,
      "y": 313.5621301775148,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1301.9644970414201,
      "ty": 309.0177514792899,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1301.9644970414201,
      "y": 309.0177514792899,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1304.2366863905324,
      "ty": 304.47337278106505,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1304.2366863905324,
      "y": 304.47337278106505,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1306.508875739645,
      "ty": 299.92899408284023,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1306.508875739645,
      "y": 299.92899408284023,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1306.508875739645,
      "ty": 295.38461538461536,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1306.508875739645,
      "y": 295.38461538461536,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1306.508875739645,
      "ty": 288.5680473372781,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1306.508875739645,
      "y": 288.5680473372781,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1308.7810650887573,
      "ty": 284.02366863905326,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1308.7810650887573,
      "y": 284.02366863905326,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1308.7810650887573,
      "ty": 279.4792899408284,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1308.7810650887573,
      "y": 279.4792899408284,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1311.0532544378698,
      "ty": 274.93491124260356,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1311.0532544378698,
      "y": 274.93491124260356,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1315.5976331360946,
      "ty": 270.3905325443787,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1315.5976331360946,
      "y": 270.3905325443787,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1320.1420118343194,
      "ty": 268.1183431952663,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1320.1420118343194,
      "y": 268.1183431952663,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1324.6863905325442,
      "ty": 265.8461538461538,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1324.6863905325442,
      "y": 265.8461538461538,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1326.9585798816568,
      "ty": 261.301775147929,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1326.9585798816568,
      "y": 261.301775147929,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1329.2307692307693,
      "ty": 256.7573964497041,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1329.2307692307693,
      "y": 256.7573964497041,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1333.775147928994,
      "ty": 252.21301775147927,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1333.775147928994,
      "y": 252.21301775147927,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1338.3195266272187,
      "ty": 247.66863905325445,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1338.3195266272187,
      "y": 247.66863905325445,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1342.8639053254437,
      "ty": 245.39644970414201,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1342.8639053254437,
      "y": 245.39644970414201,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1347.4082840236686,
      "ty": 243.12426035502958,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1347.4082840236686,
      "y": 243.12426035502958,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1349.680473372781,
      "ty": 238.57988165680473,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1349.680473372781,
      "y": 238.57988165680473,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1354.224852071006,
      "ty": 234.03550295857988,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1354.224852071006,
      "y": 234.03550295857988,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1356.4970414201182,
      "ty": 229.491124260355,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1356.4970414201182,
      "y": 229.491124260355,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1361.0414201183432,
      "ty": 224.9467455621302,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1361.0414201183432,
      "y": 224.9467455621302,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1365.585798816568,
      "ty": 222.67455621301775,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1365.585798816568,
      "y": 222.67455621301775,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1370.1301775147929,
      "ty": 220.4023668639053,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1370.1301775147929,
      "y": 220.4023668639053,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1374.6745562130177,
      "ty": 218.13017751479288,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1374.6745562130177,
      "y": 218.13017751479288,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1379.2189349112425,
      "ty": 218.13017751479288,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1379.2189349112425,
      "y": 218.13017751479288,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1383.7633136094673,
      "ty": 215.85798816568047,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1383.7633136094673,
      "y": 215.85798816568047,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1388.3076923076922,
      "ty": 215.85798816568047,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1388.3076923076922,
      "y": 215.85798816568047,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1392.8520710059172,
      "ty": 213.58579881656806,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1392.8520710059172,
      "y": 213.58579881656806,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1397.396449704142,
      "ty": 213.58579881656806,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1397.396449704142,
      "y": 213.58579881656806,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1401.9408284023668,
      "ty": 211.31360946745562,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1401.9408284023668,
      "y": 211.31360946745562,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1406.4852071005917,
      "ty": 211.31360946745562,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1406.4852071005917,
      "y": 211.31360946745562,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1411.0295857988165,
      "ty": 209.04142011834318,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1411.0295857988165,
      "y": 209.04142011834318,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1415.5739644970413,
      "ty": 209.04142011834318,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1415.5739644970413,
      "y": 209.04142011834318,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1420.118343195266,
      "ty": 209.04142011834318,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1420.118343195266,
      "y": 209.04142011834318,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1424.6627218934912,
      "ty": 211.31360946745562,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1424.6627218934912,
      "y": 211.31360946745562,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1429.2071005917157,
      "ty": 211.31360946745562,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1429.2071005917157,
      "y": 211.31360946745562,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1433.7514792899408,
      "ty": 211.31360946745562,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1433.7514792899408,
      "y": 211.31360946745562,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1438.2958579881656,
      "ty": 211.31360946745562,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1438.2958579881656,
      "y": 211.31360946745562,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1442.8402366863907,
      "ty": 211.31360946745562,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1442.8402366863907,
      "y": 211.31360946745562,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1447.3846153846152,
      "ty": 211.31360946745562,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1447.3846153846152,
      "y": 211.31360946745562,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1451.92899408284,
      "ty": 211.31360946745562,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1451.92899408284,
      "y": 211.31360946745562,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1456.473372781065,
      "ty": 215.85798816568047,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1456.473372781065,
      "y": 215.85798816568047,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1454.2011834319526,
      "ty": 215.85798816568047,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }],
    "x": 0,
    "y": 0,
    "cx": 0,
    "cy": 0,
    "cx2": 0,
    "cy2": 0,
    "tx": 0,
    "ty": 0,
    "width": 0,
    "height": 0,
    "r": 0,
    "fill": false,
    "selected": false
  }, {
    "title": "",
    "desc": "",
    "type": "lasso",
    "color": "red",
    "children": [{
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1338.3195266272187,
      "y": 456.71005917159755,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1333.775147928994,
      "ty": 461.2544378698225,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1333.775147928994,
      "y": 461.2544378698225,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1329.2307692307693,
      "ty": 463.5266272189349,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1329.2307692307693,
      "y": 463.5266272189349,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1324.6863905325442,
      "ty": 468.07100591715977,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1324.6863905325442,
      "y": 468.07100591715977,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1324.6863905325442,
      "ty": 472.61538461538464,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1324.6863905325442,
      "y": 472.61538461538464,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1322.414201183432,
      "ty": 477.15976331360946,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1322.414201183432,
      "y": 477.15976331360946,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1322.414201183432,
      "ty": 481.7041420118343,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1322.414201183432,
      "y": 481.7041420118343,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1322.414201183432,
      "ty": 486.24852071005915,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1322.414201183432,
      "y": 486.24852071005915,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1322.414201183432,
      "ty": 490.79289940828403,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1322.414201183432,
      "y": 490.79289940828403,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1324.6863905325442,
      "ty": 495.3372781065089,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1324.6863905325442,
      "y": 495.3372781065089,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1324.6863905325442,
      "ty": 499.8816568047337,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1324.6863905325442,
      "y": 499.8816568047337,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1324.6863905325442,
      "ty": 504.42603550295854,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1324.6863905325442,
      "y": 504.42603550295854,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1326.9585798816568,
      "ty": 508.9704142011834,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1326.9585798816568,
      "y": 508.9704142011834,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1331.5029585798818,
      "ty": 511.2426035502958,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1331.5029585798818,
      "y": 511.2426035502958,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1333.775147928994,
      "ty": 506.698224852071,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1333.775147928994,
      "y": 506.698224852071,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1336.0473372781064,
      "ty": 502.1538461538461,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1336.0473372781064,
      "y": 502.1538461538461,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1336.0473372781064,
      "ty": 497.60946745562126,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1336.0473372781064,
      "y": 497.60946745562126,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1336.0473372781064,
      "ty": 493.06508875739644,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1336.0473372781064,
      "y": 493.06508875739644,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1336.0473372781064,
      "ty": 488.52071005917156,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1336.0473372781064,
      "y": 488.52071005917156,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1336.0473372781064,
      "ty": 483.97633136094674,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1336.0473372781064,
      "y": 483.97633136094674,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1336.0473372781064,
      "ty": 479.4319526627218,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1336.0473372781064,
      "y": 479.4319526627218,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1336.0473372781064,
      "ty": 474.887573964497,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1336.0473372781064,
      "y": 474.887573964497,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1338.3195266272187,
      "ty": 470.3431952662722,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1338.3195266272187,
      "y": 470.3431952662722,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1338.3195266272187,
      "ty": 465.7988165680473,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1338.3195266272187,
      "y": 465.7988165680473,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1338.3195266272187,
      "ty": 461.2544378698225,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1338.3195266272187,
      "y": 461.2544378698225,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1338.3195266272187,
      "ty": 456.71005917159755,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1338.3195266272187,
      "y": 456.71005917159755,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1338.3195266272187,
      "ty": 456.71005917159755,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }, {
      "title": "",
      "desc": "",
      "type": "line",
      "color": "red",
      "children": [],
      "x": 1338.3195266272187,
      "y": 456.71005917159755,
      "cx": 0,
      "cy": 0,
      "cx2": 0,
      "cy2": 0,
      "tx": 1338.3195266272187,
      "ty": 456.71005917159755,
      "width": 0,
      "height": 0,
      "r": 0,
      "fill": false,
      "selected": false
    }],
    "x": 0,
    "y": 0,
    "cx": 0,
    "cy": 0,
    "cx2": 0,
    "cy2": 0,
    "tx": 0,
    "ty": 0,
    "width": 0,
    "height": 0,
    "r": 0,
    "fill": false,
    "selected": false
  }]
}